import { AuthServiceInterface } from './AuthServiceInterface.js';
import { setAuthForAccessToken } from './middlewares/applyAccessToken.js';
import { setAuthForErrorInterceptor } from './middlewares/responseErrorInterceptor.js';

export function setAuth(auth: AuthServiceInterface) {
  setAuthForAccessToken(auth);
  setAuthForErrorInterceptor(auth);
}
